export default __webpack_public_path__ + "static/media/GT-America-Mono-Bold.6772bf71.woff";